import { useReducer } from 'react';
export function useForceUpdate() {
  var _a = useReducer(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _a[1];

  return forceUpdate;
}